import React from 'react'
import { useRouter } from 'next/router'
import { stringify } from 'query-string'

import {
  HeaderBar,
  HeaderBarTitle,
  HeaderBarLeftAction,
} from '@wartek-id/header-bar'

import Quiz from 'app/PelatihanMandiriPage/pages/Quiz'
import { WithLayoutListener } from 'components/Layout/Desktop/DesktopLayout'

import CloseIcon from 'assets/icons/close.svg'

const QuizPage = (props) => {
  const { isDesktopScreenSize } = props

  return (
    <WithLayoutListener isDesktop={isDesktopScreenSize}>
      <Quiz isDesktop={isDesktopScreenSize} />
    </WithLayoutListener>
  )
}

const PageHeader = () => {
  const { query, replace } = useRouter()
  const backUrl =
    `/${
      process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || 'pelatihan-mandiri'
    }/modul/${query.modul}?` +
    stringify({
      topik: query.topik,
      topik_name: query.topik_name,
    })

  return (
    <HeaderBar fixed className="z-10">
      <HeaderBarLeftAction
        data-testid="back-button"
        icon={<CloseIcon className="stroke-current text-default" />}
        onClick={() => replace(backUrl)}
      />
      <HeaderBarTitle>Latihan Pemahaman</HeaderBarTitle>
    </HeaderBar>
  )
}

QuizPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default',
  header: PageHeader,

  enableDesktopLayout: true,
}

export default QuizPage
